import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { SpecialtyModel } from '../../models/specialty';
import { storeData } from '../../utils/converter';
import { getSpecialties } from '../../apis/emr-data';

export interface State {
    allIds: number[];
    byId: Dictionary<SpecialtyModel>;
    loading: Dictionary<boolean>;
}

export const specialties = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: SpecialtyModel[],
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeData(data, 'id')
            };
            return {
                ...state,
                allIds: Object.keys(byId).map(x => +x),
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getSpecialtiesAsync(_: Undefinable<{}>, rootState: RootState) {
            if (selectors.getSpecialtyIds(rootState.specialties).length === 0) {
                try {
                    const data = await getSpecialties();
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});
